const initialState = {
    notifications: []
}

interface INotificationPayload {
    type: string;
    payload: INotificationPayloadData;
}
export interface INotificationPayloadData {

    id: number;
    title: string;
    description: string;
    variant?: string;

}

export const notificationsReducer = (state = initialState, action: INotificationPayload) => {
    switch (action.type) {
        case 'ADD_NOTIFICATION':
            return {
                ...state,
                notifications: [...state.notifications, action.payload]
            }
        case 'REMOVE_NOTIFICATION':
            return {
                ...state,
                notifications: state.notifications.filter((notification: any) => notification.id !== action.payload)
            };
        default:
            return state;
    }
}